export default __webpack_public_path__ + "static/codeleap_logo_black-04b598d62db1481b346351e041f46414.webp";